export default __webpack_public_path__ + "locales/sl/PeopleTranslations.json?hash=af55465354ff06df250f090806b450d9";